import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=16c4e13c&scoped=true&"
import script from "./Packs.vue?vue&type=script&lang=ts&"
export * from "./Packs.vue?vue&type=script&lang=ts&"
import style0 from "./Packs.vue?vue&type=style&index=0&id=16c4e13c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c4e13c",
  null
  
)

export default component.exports